import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints';

export async function getMonthlyLeadsReport(query) {
    try {
        let response = await axios.get(`${LEADS_ENDPOINT}/generateExcel${query}`,
        {
            timeout: 1800000 // 30 minutos
        });
        return response.data
    } catch(error) {
        throw new Error(error);
    }
}
